interface IVersionFileContent {
  buildId?: unknown;
}

export async function fetchRemoteBuildId(): Promise<string | undefined> {
  try {
    const versionFileUrl = new URL("/version.json", window.location.origin).toString();
    const response = await fetch(versionFileUrl, { cache: "no-store" });
    if (!response.ok) {
      return undefined;
    }

    const content = (await response.json()) as IVersionFileContent;
    const isValidBuildId = typeof content.buildId === "string" && content.buildId.length > 0;
    if (!isValidBuildId) {
      return undefined;
    }

    return content.buildId as string;
  } catch {
    // The version check must never break the app
    return undefined;
  }
}
